// src/services/ComplaintsService.js
import axiosInstance from './AxiosInstance';

function isFileLike(f) {
  const hasFile = typeof File !== 'undefined' && f instanceof File;
  const hasBlob = typeof Blob !== 'undefined' && f instanceof Blob;
  return hasFile || hasBlob;
}

function joinUrl(base = '', p = '') {
  const left = String(base).replace(/\/+$/, '');
  const right = String(p).replace(/^\/+/, '');
  return `${left}/${right}`;
}

const baseURL = axiosInstance?.defaults?.baseURL || '';

export const getComplaints = (params) => {
  return axiosInstance.get('complaints/list', { params });
};

export const createComplaint = (data, file = null) => {
  if (isFileLike(file)) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('transactionId', String(data.transactionId));
    fd.append('complaint', data.complaint);
    if (data.imageURL) fd.append('imageURL', data.imageURL);
    return axiosInstance.post('complaints/create', fd);
  }
  return axiosInstance.post('complaints/create', data);
};

export const fetchComplaintById = (id) => {
  return axiosInstance.get(`complaints/${id}`);
};

export const addComplaintReply = (id, payload, file = null) => {
  if (isFileLike(file)) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('message', payload?.message ?? '');
    if (payload?.imageURL) fd.append('imageURL', payload.imageURL);
    return axiosInstance.post(`complaints/${id}/reply`, fd);
  }
  return axiosInstance.post(`complaints/${id}/reply`, payload);
};

export const getComplaintReplies = (id) => {
  return axiosInstance.get(`complaints/${id}/replies`);
};

export const downloadComplaintFile = (id) => {
  return axiosInstance.get(`complaints/${id}/file`, { responseType: 'blob' });
};

export const downloadReplyFile = (replyId) => {
  return axiosInstance.get(`complaints/replies/${replyId}/file`, { responseType: 'blob' });
};

export const getComplaintFileUrl = (id) => joinUrl(baseURL, `complaints/${id}/file`);
export const getReplyFileUrl = (replyId) => joinUrl(baseURL, `complaints/replies/${replyId}/file`);